import { createContext } from "react";

import DeviceDetectService from "core/services/deviceDetectService";

const DeviceContext = createContext(DeviceDetectService.detect());

export default DeviceContext;